
import { defineComponent, ref, toRefs } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import StatusBlock from "./StatusBlock.vue";
import LoadingModal from "./LoadingModal.vue";
import { States, submitHandler } from "./submit_handler";
import { UserService } from "@/services/user";
import { useAuthStore } from "@/store/auth";

export default defineComponent({
  components: { Form, Field, ErrorMessage, StatusBlock, LoadingModal },
  props: {
    formDisabled: {
      type: Boolean,
      required: true
    },
    plan: {
      type: Object,
      required: true
    }
  },
  emits: ["discountApplied"],
  setup(props, { emit }) {
    const auth = useAuthStore();
    let states: States = {
      recaptcha: null,
      loadingShow: ref(false),
      errorMessage: ref(""),
      captchaEnabled: false
    };
    const coupon = ref("");
    const { plan } = toRefs(props);
    async function applyCoupon() {
      if (!auth.accessToken) {
        auth.logout();
        return;
      }

      await submitHandler(
        UserService.getDiscount(auth.accessToken, { couponCode: coupon.value, planCode: plan.value.code }),
        states,
        discount => {
          emit("discountApplied", { code: coupon.value, discount });
        }
      );
    }

    return {
      loadingShow: states.loadingShow,
      errorMessage: states.errorMessage,
      coupon,
      applyCoupon
    };
  }
});
